import { BillingCommentUnsuccessfulComponent } from '../billing-comment/billing-comment-unsuccessful/billing-comment-unsuccessful.component';
import { BillingCommentComponent } from '../billing-comment/billing-comment-successful/billing-comment.component';
import { MapfreButtonComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreModalComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-modal/mapfre-modal.component';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, NO_ERRORS_SCHEMA } from '@angular/core';
import { PolicyDataService } from '../../../../../_services/data-services/policy-data.service';
import { ActivatedRoute, Params, Router, RouterModule } from '@angular/router';
import { FormGroup, FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StorageServiceObservablesService } from '../../../../../_services/storage-service-observables/storage-service-observables.service';
import { BillingDetailsService } from '../../../../../_services/my-insurance/billing-details.service';
import {
  ModalOptions,
  AcmicService,
  GTagService,
} from '@mapfre-design-library/src/public_api';
import { TranslateService } from '@ngx-translate/core';
import { NavigationService } from '@services/navigation.service';
import { BillingRequestService } from '@services/billing-request.service';
import { ActionType } from '@models/widget/action-type.enum';
import { TitleCasePipe } from '@angular/common';

@Component({
  standalone: true,
  schemas: [NO_ERRORS_SCHEMA],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MdbFormsModule, MapfreModalComponent, MapfreButtonComponent, BillingCommentComponent, BillingCommentUnsuccessfulComponent],
  selector: 'app-billing-question',
  templateUrl: './billing-question.component.html',
  styleUrls: ['./billing-question.component.scss'],
})
export class BillingQuestionComponent implements OnInit {
  @Input() onModalLoad: boolean;
  @Output() closeModal: EventEmitter<boolean> = new EventEmitter();
  @Input() buttonText = 'ASK_QUESTION';
  @Input() isLegacy = true;
  @Input() landingFrom: string;

  loader: boolean;
  policies: any = [];
  policyId: string;
  billingQuestionFormGroup: FormGroup;
  isFormValid = true;
  invalidTopic = true;
  invalidPolicy = true;
  invalidText = true;
  hoveredIndex: number = null;
  hoveredTopicIndex: number = null;
  policyData: any;
  otherPolicies: any;
  showSuccessModal: boolean;
  showFailureModal: boolean;
  sendQuestionModal: ModalOptions;
  hideMainModal = true;
  hideModal: boolean;
  hideMain: boolean;
  isAcmic: boolean;
  inputs: any[];
  topics: any[];
  stateCode: string;
  isMA = true;
  modalIcon: string;
  topicDropdownHeight = 24;

  constructor(
    private policyDataService: PolicyDataService,
    private activatedRoute: ActivatedRoute,
    private storageObservable: StorageServiceObservablesService,
    private billingDetailsService: BillingDetailsService,
    private acmicService: AcmicService,
    private gTagService: GTagService,
    private translate: TranslateService,
    private navService: NavigationService,
    private router: Router,
    private billingRequestService: BillingRequestService,
    private titleCasePipe: TitleCasePipe
  ) { }

  unhideModal() {
    this.hideModal = false;
  }

  onTryAgain(event) {
    if (event) {
      this.hideModal = false;
      this.displayModal();
    }
  }

  onSelectionChange(policy: any) {
    this.isMA = policy.policyNumber && (policy.policyNumber.length == 6 || policy.policyNumber.length == 10);
    if (this.isMA) {
      this.onChange(policy.policyNumber);
    }
  }

  onPolicyClose(event: any) {
    void event;
    if (!this.billingQuestionFormGroup.controls.policies.value)
      this.hoveredIndex = null;
  }

  onMessageTopicChange(topic: any) {
    if (topic?.label?.toLowerCase() === "cancellations" && this.billingQuestionFormGroup.controls.policies.value) {
      this.router.navigate(
        ['/my-insurance', this.billingQuestionFormGroup.controls.policies.value.trim(), 'self-request', 'cancellations']
      );
      return;
    }
  }

  onTopicClose(event: any) {
    void event;
    if (!this.billingQuestionFormGroup.controls.inquiryTopic.value)
      this.hoveredTopicIndex = null;
    this.topicDropdownHeight = 24;//top margin
  }

  onTopicOpen(event: any) {
    void event;
    const optionHeight = 24 + ((this.isAcmic) ? 8 : 4);//line-height + top&bottom padding
    this.topicDropdownHeight += Math.min(240, this.topics.length * optionHeight);//+ top margin
  }

  sendQuestion() {
    this.isFormValid = true;
    if (
      this.policies.length > 1 && (!this.billingQuestionFormGroup.controls.policies.value
        || this.billingQuestionFormGroup.controls.policies.value.toLowerCase() == 'select one')
    ) {
      this.isFormValid = false;
      this.invalidPolicy = false;
      this.gTagService.triggerFormLink(
        'billingQuestionForm',
        'false',
        this.translate.instant('POLICY_NOT_SELECTED')
      );
    }
    if (
      !this.billingQuestionFormGroup.controls.inquiryTopic.value
      || this.billingQuestionFormGroup.controls.inquiryTopic.value.toLowerCase() == 'select one'
    ) {
      this.isFormValid = false;
      this.invalidTopic = false;
      this.gTagService.triggerFormLink(
        'billingQuestionForm',
        'false',
        this.translate.instant('INQUIRY_TOPIC_NOT_SELECTED')
      );
    }
    if (!this.billingQuestionFormGroup.controls.inquiryText.value) {
      this.isFormValid = false;
      this.invalidText = false;
      this.gTagService.triggerFormLink(
        'billingQuestionForm',
        'false',
        this.translate.instant('REQUIRED_INQUIRY_TEXT')
      );
    }
    if (this.isFormValid) {
      if (this.policies.length > 1) {
        this.policyData = this.policies.filter(
          (policy) =>
            policy.policyNumber ==
            this.billingQuestionFormGroup.controls.policies.value.trim()
        )[0];
        this.otherPolicies = this.policies
          .filter(
            (policy) =>
              policy.policyNumber &&
              policy.policyNumber !==
              this.billingQuestionFormGroup.controls.policies.value.trim()
          )
          .map(
            (policy) => {
              let sys = 'Guidewire';
              if (policy.company == 'TW') {
                sys = 'TW'
              } else if (policy.company == 'ACIC') {
                sys = 'V12'
              } else if (policy.policyNumber.length == 6) {
                sys = 'AS400'
              } else {
                sys = 'Guidewire'
              }
              return sys +
                ' - ' +
                (policy.displayType?.label?.toUpperCase() ?? policy.policyType) +
                ' - ' +
                policy.policyNumber
            }
          );
      } else {
        this.policyData = this.policies[0];
      }

      this.policyData['inquiryDate'] = new Date().toLocaleDateString();
      this.policyData['inquiryTime'] = new Date().toLocaleTimeString();
      this.policyData['inquiryTopic'] =
        this.billingQuestionFormGroup.controls.inquiryTopic.value;
      this.policyData['inquiry'] =
        this.billingQuestionFormGroup.controls.inquiryText.value;
      this.policyData['email'] = this.storageObservable.getUserFromStorage();
      this.policyData['otherPolicies'] = this.otherPolicies;
      this.policyData['contact'] =
        this.policyData.policyNumber.length == 6
          ? '1-800-922-8276'
          : '1-855-627-3737';
      this.submitBillingQuestion();
    }
  }

  submitBillingQuestion() {
    this.loader = true;
    this.billingDetailsService
      .sendBillingQuestion(
        this.policyData,
        this.storageObservable.getUserFromStorage()
      )
      .subscribe(
        () => {
          this.gTagService.triggerFormLink('billingQuestionForm', 'true', '');
          this.hideMain = true;
          this.sendQuestionModal.modalTranslateCopy = '';
          this.showSuccessModal = true;
          this.showFailureModal = false;
          this.loader = false;
        },
        () => {
          this.gTagService.triggerFormLink(
            'billingQuestionForm',
            'false',
            this.translate.instant('BILLING_QUESTION_ERROR')
          );
          this.hideMain = true;
          this.sendQuestionModal.modalTranslateCopy = '';
          this.showFailureModal = true;
          this.showSuccessModal = false;
          this.loader = false;
        }
      );
  }

  resetHideModal(event): void {
    this.closeModal.emit(true);

    if (event) {
      this.hideModal = !this.hideModal;
      this.displayModal();
    }
  }

  onClickBack(event) {
    if (event) {
      this.hideModal = true;
      this.displayModal();
      this.closeModal.emit(true);
    }
  }

  onHideModal() {
    this.clearForm();
    this.closeModal.emit(true);
  }

  displayModal() {
    this.hideMainModal = true;
    this.hideMain = false;
    this.showSuccessModal = false;
    this.showFailureModal = false;
    this.sendQuestionModal.modalTranslateCopy = '';
    this.clearForm();
  }

  clearForm() {
    const policiesRequired = this.policies.length > 1 ? Validators.required : null;
    this.billingQuestionFormGroup = new FormGroup({
      policies: new FormControl(this.policyId ? this.policyId : null, policiesRequired),
      inquiryTopic: new FormControl(null, Validators.required),
      inquiryText: new FormControl('', Validators.required),
    });
    this.invalidPolicy = true;
    this.invalidTopic = true;
    this.invalidText = true;
    this.hoveredIndex = null;
    this.hoveredTopicIndex = null;
  }

  onChange(selectedPolicyNumber: string) {
    const selectedPolicy = this.policies.find(policy => policy.policyNumber === selectedPolicyNumber);
    this.setDynamicTopic(selectedPolicy);
  }

  setDynamicTopic(selectedPolicy) {
    if (selectedPolicy) {
      const { jurisdictionState, policyNumber } = selectedPolicy;
      if (jurisdictionState === 'MA' && policyNumber.length === 10) {
        this.inputs = this.billingRequestService.getMAInputs();
        this.mapTopics();
      }
    }
  }

  OnBlur() {
    this.invalidText =
      !!this.billingQuestionFormGroup.controls['inquiryText'].value;
  }

  saveAction() {
    this.navService.saveCurrentAction(ActionType.AskQuestion);
  }

  ngOnInit() {
    this.isAcmic = this.acmicService.isACMIC();
    this.modalIcon = this.isAcmic
      ? "./assets/img/images/ask-question-modal-acmic.svg"
      : "./assets/img/images/ask-question-modal.svg";

    const buttonCopy = this.buttonText;
    let additionalButtonClasses = this.isAcmic ? 'ghost warn-ghost' : 'ghost warn-ghost fs-16';
    const modalTranslateCopy = '';
    const additionalClasses = `billing-quetion-modal modal-medium modal-dialog modal-center-on-page ${this.isAcmic ? '' : 'modal-dialog-scrollable'
      }`;
    this.inputs = this.billingRequestService.getNonMAGWInputs();
    if (this.isAcmic) {
      this.inputs = this.billingRequestService.getAcmicInputs();
      additionalButtonClasses =
        'ghost secondary letter-space-17 billing-sidebar-btn';
    }
    this.hideMain = false;
    this.hideModal = false;
    this.sendQuestionModal = new ModalOptions({
      additionalClasses,
      additionalButtonClasses,
      buttonCopy,
      modalId: 'sendQuestion',
      modalTranslateCopy,
      modalName: 'billing_Question',
      onLoad: this.onModalLoad ? true : false,
    });

    this.activatedRoute.params.subscribe((params: Params) => {
      this.policyId = params['policyid'];
    });

    this.policyDataService.$policyDetails.subscribe((policyResponse: any) => {
      if (policyResponse) {
        policyResponse.forEach((policy) =>
          this.policies.push({
            policyNumber: policy.policynumber.policyNumber,
            policyType: policy?.displayType?.label?.toUpperCase() ?? policy?.policyType,
            typeNumTitle: policy.displayType?.label + " - " + policy.policynumber.policyNumber,
            state: policy.residentialAddress.stateCode,
            jurisdictionState: policy.jurisdiction?.state,
            company: policy.company.companyName,
            isPaperless: policy.policyFlags.isEdf === 'ENROLLED' ? 'Yes' : 'No',
            isAutoPay: policy.policyFlags.isEft === 'ENROLLED' ? 'Yes' : 'No',
            firstName: policy.insured.filter(
              (insured) => insured.isPrimaryInsured
            )[0].firstName,
            lastName: policy.insured.filter(
              (insured) => insured.isPrimaryInsured
            )[0].lastName,
            disabled: false
          })
        );

        if (this.policies.length === 1) {
          this.setDynamicTopic(this.policies[0].policyNumber);
        }
        // else {
        //   this.policies.unshift({policyNumber: null, typeNumTitle: 'Select one', disabled: true});
        // }
        this.mapTopics();
      }
    });

    this.clearForm();
  }

  private mapTopics() {
    this.topics = this.inputs.map(input => ({
      label: input,
      disabled: false
    }))
    // this.topics.unshift({label: 'Select one', disabled: true});
  }
}
